export default function sortData(data, sortColumn, sortType){
    return data.sort((a, b) => {
      const aValue = a[sortColumn];
      const bValue = b[sortColumn];

      // Handle null/undefined values: always sort them last for asc, first for desc
      const aIsNil = aValue === null || aValue === undefined;
      const bIsNil = bValue === null || bValue === undefined;
      if (aIsNil && bIsNil) return 0;
      if (aIsNil) return sortType === "asc" ? -1 : 1;
      if (bIsNil) return sortType === "asc" ? 1 : -1;

      // Generic date-like sorting: if both values can be parsed as dates, sort as dates
      const aDate = new Date(aValue);
      const bDate = new Date(bValue);
      const aIsDate = !isNaN(aDate.getTime());
      const bIsDate = !isNaN(bDate.getTime());
      if (aIsDate && bIsDate) {
        if (aDate.getTime() === bDate.getTime()) return 0;
        if (aDate.getTime() < bDate.getTime()) return sortType === "asc" ? 1 : -1;
        if (aDate.getTime() > bDate.getTime()) return sortType === "asc" ? -1 : 1;
      }
      // Standard comparison for other types
      if (aValue < bValue) return sortType === "asc" ? 1 : -1;
      if (aValue > bValue) return sortType === "asc" ? -1 : 1;
      return 0;
    });
}